import { useEffect, useMemo } from "react"

import Popover from "./Popover"

const Item = ({ config, position, type, onSpaceChange, spaceType, onEditing, editing }) => {
  const positionClass = {
    top: 'top-2 left-1/2 -translate-x-1/2',
    bottom: 'bottom-2 left-1/2 -translate-x-1/2',
    left: 'left-2 top-1/2 -translate-y-1/2',
    right: 'right-2 top-1/2 -translate-y-1/2',
  }

  const handleChange = ({ value, unit, predefined }) => {
    onSpaceChange({ type, position, unit, value, predefined })
  }

  const active = useMemo(() => {
    if (!editing.value) return false
    if (editing.type !== type) return false

    if (spaceType === 'all') return true
    if (spaceType === 'axis') {
      if (['top', 'bottom'].includes(editing.position) && ['top', 'bottom'].includes(position)) return true
      if (['left', 'right'].includes(editing.position) && ['left', 'right'].includes(position)) return true
      return false
    }
    if (editing.position === position) return true

    return false
  }, [editing, type, position, spaceType])

  const activeClass = active ? 'bg-gray-600/20 dark:hover:bg-gray-600/20 twy-text-base-accent' : ''

  useEffect(() => {
    if (!config.value && !config.unit) {
      config.unit = 'px'
    }
  }, [config, type, position, onSpaceChange])

  return <>
    <Popover onChange={handleChange} config={config} onEditing={onEditing} position={position} type={type}>
      <span className={`${activeClass} w-[35px] py-1 absolute twy-text-base flex items-center justify-center gap-0.5 rounded-xs cursor-pointer twy-subtle-neutral-hover hover:twy-text-base-accent ${positionClass[position]}`}>
        <span className='text-sm'>{config.value || '-'}</span>
        {!config.predefined && <span className='text-sm opacity-50'>{config.value ? config.unit : ''}</span>}
      </span>
    </Popover>
  </>
}

export default Item
